const expires = new Date()
expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000)

function parseJSON(string?: string | null) {
  if (!string) return null
  try {
    return JSON.parse(string)
  } catch (e) {
    return string
  }
}

export default <T>(name: string) => {
  try {
    const cookie = useCookie(name, { expires })
    const state = useState(name, () => parseJSON(cookie.value) as T)

    watch(
      state,
      () => {
        cookie.value = JSON.stringify(state.value)
      },
      { deep: true }
    )

    return state
  } catch (e) {
    console.log('useStatefulCookie:', e)
    return useState<T>(name)
  }
}
